// extracted by mini-css-extract-plugin
export default {"ticket":"yFfEt","discount":"fr4is","row":"azQFq","name":"L0-XK","singlePrice":"-XaC4","price":"-dQAc","quantity":"_2I90L","total":"bGzWx","priceItem":"mHMfl"};